import * as React from "react";
import type { SVGProps } from "react";
const SvgPaddleSyncFailed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={18}
    fill="none"
    viewBox="0 0 22 18" {...props}
  >
    <rect width={18} height={18} fill="#8B9FFE" rx={4} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M5.6 3.3h5.3a4.78 4.78 0 1 1 0 9.56H7.88v1.91c0 .75-.61 1.36-1.36 1.36s-1.36-.61-1.36-1.36V3.3zm2.32 2.46h3c1.28 0 2.32 1.04 2.32 2.32s-1.04 2.32-2.32 2.32h-3z"
      clipRule="evenodd"
    />
    <circle cx={18} cy={4} r={4} fill="#FF5252" />
  </svg>
);
export default SvgPaddleSyncFailed;
